import { IButton } from './IButton';

const SecondaryButton = (props: IButton & { className?: string }) => {
  const { handleOnClick, children, width, height, disabled, hidden, className } = props;

  return (
    <button
      style={{ width: width || 'auto', height: height || 'auto' }}
      className={`${height ? '' : '!h-fit'} rounded-full bg-default px-2 md:px-4 lg:px-6 py-2 font-normal !leading-none text-white transition-shadow ease-in hover:shadow-md ${className || ''}`}
      onClick={handleOnClick}
      disabled={disabled}
      hidden={hidden}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
